// Callback navigation can wait for context before the router commits its destination.
let pendingTarget: { path: string } | null = null;

export function navigateForContext(
    path: string,
    push: (target: { path: string }) => unknown
): Promise<void> {
    const target = { path };
    pendingTarget = target;
    return Promise.resolve(push(target))
        .then(() => undefined)
        .finally(() => {
            if (pendingTarget === target) {
                pendingTarget = null;
            }
        });
}

export function takeContextNavigationTarget(): string | null {
    const target = pendingTarget?.path ?? null;
    pendingTarget = null;
    return target;
}
